import set from 'lodash/set'
import { z } from 'zod'

import { groupProperties, userProperties } from './BaseModels'
import cachedDummies from './cachedDummies'
import { groupPermissions } from './CurrentUser'
import { groupLearningAssignmentParser } from './GroupLearningAssignment'
import parseModel from './parseModel'

export const groupParser = z.preprocess(
  (o: any) => {
    const permissions = Object.fromEntries(Object.keys(groupPermissions).map((name) => [name, false]))
    for (const p of o.permissions || []) {
      set(permissions, p.replace(/^group\./, ''), true)
    }
    o.permissions = permissions
    return o
  },
  z.object({
    ...groupProperties,

    members: z.array(z.object(userProperties)).default(() => []),
    managers: z.array(z.object(userProperties)).default(() => []),

    groupLearningAssignments: z.array(groupLearningAssignmentParser).nullish(), // ???

    permissions: z.object({
      ...groupPermissions,
    }),
  })
)

export type Group = z.infer<typeof groupParser>

export const dummyGroup = cachedDummies(
  (uuid: string, error?: any): Group => ({
    isDummy: true,
    error,
    uuid,

    clientUuid: 'dummy',

    name: 'Lorem ipsum',

    createdAt: new Date(),
    updatedAt: new Date(),

    members: [],
    managers: [],

    groupLearningAssignments: [],

    permissions: Object.fromEntries(Object.keys(groupPermissions).map((name) => [name, false])) as any,
  })
)

export const parseGroup = parseModel<Group>(groupParser, dummyGroup)
